// src/components/CustomerSelectModal.tsx

import React from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import { Customer } from '../types';

interface CustomerSelectModalProps {
  show: boolean;
  onHide: () => void;
  customers: Customer[];
  handleCustomerUpdate: (customerId: number) => void;
  handleShowCreateCustomerModal: () => void;
}

const CustomerSelectModal: React.FC<CustomerSelectModalProps> = ({
  show,
  onHide,
  customers,
  handleCustomerUpdate,
  handleShowCreateCustomerModal
}) => {
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Select or Create Plesk Customer</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group controlId="customerSelection">
          <Form.Label>Customer</Form.Label>
          <Form.Control as="select" onChange={(e) => handleCustomerUpdate(Number(e.target.value))}>
            <option key="0" value="0">
              Choose a customer
            </option>
            {customers.map((customer) =>
              customer.id !== null ? (
                <option key={customer.id} value={customer.id}>
                  {customer.company} - {customer.email}
                </option>
              ) : null
            )}
          </Form.Control>
        </Form.Group>
        <Button variant="success" onClick={handleShowCreateCustomerModal}>
          Create New Customer
        </Button>
      </Modal.Body>
    </Modal>
  );
};

export default CustomerSelectModal;
